import { useUnit } from 'effector-react'
import { $blockedGatewayIds } from '../model'
import { $allGateways, $allGatewaysTotal, getAllGatewaysFx } from './model'

export const useAllGateways = () => {
  const gateways = useUnit($allGateways)
  const total = useUnit($allGatewaysTotal)
  const loading = useUnit(getAllGatewaysFx.pending)
  const blockedGatewayIds = useUnit($blockedGatewayIds)

  return { gateways, total, loading, blockedGatewayIds }
}
